module.exports = __webpack_public_path__ + "static/img/banner.ce9c653.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/banner.png
// module id = fxsv
// module chunks = 0